module.exports = __webpack_public_path__ + "assets/img/logo.935de62f.svg";